import Button from '@components/Button';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { useTranslation } from 'react-i18next';

import useSignUp from './hooks/useSignUp';

function SignUpButton() {
    const { t } = useTranslation('signUp');
    const { signUpEnabled, signUp } = useSignUp();
    const project = useProject();
    return (
        <Wrapper>
            <Button fullWidth disabled={!signUpEnabled}
                onClick={signUp}>
                {project?.features.authenticationEnabled ? t('button.identify') : t('button.complete')}
            </Button>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    border-top: 1px solid var(--color-border-default);
    padding: var(--spacing-4) var(--spacing-4) calc(var(--safe-area-bottom) + var(--spacing-4));
    width: 100%;
`;

export default SignUpButton;
